import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { startPerfProbe } from './app/core/perf-probe';

// No-op unless a dev-menu perf capture is already running — the case of an overlay window opened
// after the switch was flipped.
void startPerfProbe();

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
